// extracted by mini-css-extract-plugin
export default {"Header":"header_Header__KL1Mn","NavItems":"header_NavItems__y5oki"};